import { render, staticRenderFns } from "./ticketForm.vue?vue&type=template&id=18244821"
import script from "./ticketForm.vue?vue&type=script&lang=js"
export * from "./ticketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports